/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*
*/

import { HttpParams } from "@angular/common/http";
import { AbuChart } from "@src/app/modules/agent/agent-dashboard-page/AbuChart";

export class AbuMyOmcChart extends AbuChart {
    title = "Action Creation for My OMCs";
    dataParams = new HttpParams().set('week', 0).set('show', 'myomcs');
}
